export function formatHistoryContent(content) {
    if (!content) return ''
    const normalizedInput = content.replace(/\r\n/g, '\n').replace(/\r/g, '\n').trim()

    let contentToFormat = content
    const sectionMatch = normalizedInput.match(/^Old Value:\n([\s\S]*?)\n\nNew Value:\n([\s\S]*)$/i)

    if (sectionMatch) {
        const parseTopLevelFields = section => {
            const lines = section.split('\n')
            const fields = []
            let current = null

            for (const line of lines) {
                const topLevelMatch = line.match(/^([^:\n]+):\s*(.*)$/)

                if (topLevelMatch && !line.startsWith(' ')) {
                    if (current) fields.push(current)
                    current = {
                        name: (topLevelMatch[1] || '').trim(),
                        value: (topLevelMatch[2] || '').trim()
                    }
                    continue
                }

                if (current) {
                    current.value = current.value ? `${current.value}\n${line}` : line
                }
            }

            if (current) fields.push(current)
            return fields
        }

        const oldFields = parseTopLevelFields(sectionMatch[1])
        const newFields = parseTopLevelFields(sectionMatch[2])

        if (oldFields.length || newFields.length) {
            const oldByName = new Map(oldFields.map(field => [field.name, field.value]))
            const newByName = new Map(newFields.map(field => [field.name, field.value]))
            const fieldNames = []

            for (const field of oldFields) {
                if (!fieldNames.includes(field.name)) fieldNames.push(field.name)
            }
            for (const field of newFields) {
                if (!fieldNames.includes(field.name)) fieldNames.push(field.name)
            }

            const messages = fieldNames
                .map(name => {
                    const oldValue = (oldByName.get(name) || '').trim()
                    const newValue = (newByName.get(name) || '').trim()

                    if (oldValue === newValue) return ''
                    return `'${name}' changed from old value: '${oldValue}' to new value: '${newValue}'`
                })
                .filter(Boolean)

            if (messages.length) {
                contentToFormat = messages.join('\n')
            }
        }
    }

    const escaped = contentToFormat
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')

    return escaped
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n')
        .split('\n')
        .map(line => {
            const indent = line.match(/^( +)/)?.[1] || ''
            const rest = line.slice(indent.length)
            return '&nbsp;'.repeat(indent.length) + rest
        })
        .join('<br>')
}
